import { Text } from '@shared/components'
import { Flex, Form, FormInstance, Input, Select, theme, Upload } from 'antd'

import { FolderMinus } from 'iconsax-react'
import { useTranslation } from 'react-i18next'

import type { TicketFormState } from '@organization/features/tickets/types'

const { Dragger } = Upload

type Props = {
  form: FormInstance<TicketFormState>
}

const priorityOptions = [
  {
    label: 'High',
    value: 'high'
  },
  {
    label: 'Medium',
    value: 'medium'
  },
  {
    label: 'Low',
    value: 'low'
  }
]

export const TicketForm = ({ form }: Props) => {
  const { token } = theme.useToken()
  const { t } = useTranslation()

  return (
    <Form form={form} layout="vertical">
      <Form.Item
        name="title"
        label={t('tickets.ticket')}
        rules={[{ required: true }]}
        required
      >
        <Input placeholder={t('tickets.example')} />
      </Form.Item>

      <Form.Item
        name="priority"
        label={t('tickets.priority')}
        rules={[{ required: true }]}
        required
      >
        <Select options={priorityOptions} placeholder={t('tickets.priority')} />
      </Form.Item>

      <Form.Item name="description" label={t('form.item.description')}>
        <Input.TextArea
          placeholder={t('tickets.example_description')}
          rows={5}
        />
      </Form.Item>

      <Form.Item
        name="attachments"
        label={t('form.item.attachments')}
        valuePropName="fileList"
        getValueFromEvent={(e) => e?.fileList}
      >
        <Dragger
          customRequest={(info) => info.onSuccess?.({})}
          multiple
          pastable
        >
          <Flex vertical gap={16} align="center">
            <FolderMinus color={token.colorPrimary} size={48} />

            <Flex vertical gap={4}>
              <div>
                <Text size={16}>
                  {t('form.message.drag_and_drop_files_here')}
                </Text>{' '}
              </div>

              <Text type="secondary">
                {t('form.message.upload_support_single_or_bulk')}
              </Text>
            </Flex>
          </Flex>
        </Dragger>
      </Form.Item>
    </Form>
  )
}
